import * as yup from 'yup';

// Inventory item form validation schema
export const inventoryValidationSchema = yup.object({
  name: yup
    .string()
    .trim()
    .required('Item name is required')
    .min(2, 'Item name must be at least 2 characters')
    .max(255, 'Item name must be less than 255 characters'),
  serial_number: yup
    .string()
    .trim()
    .max(255, 'Serial number must be less than 255 characters')
    .nullable(),
  description: yup
    .string()
    .trim()
    .max(1000, 'Description must be less than 1000 characters'),
  quantity: yup
    .number()
    .required('Quantity is required')
    .min(0, 'Quantity must be zero or greater')
    .integer('Quantity must be a whole number')
    .typeError('Quantity must be a valid number'),
});